module.exports = __webpack_public_path__ + "static/media/Canal+_PanAfrica.1306db86.png";